import { Typography, Card, CardContent, Grid } from "@mui/material"
import { User } from "src/redux/slices/dashboard/users";

type UsersItemProps = {
	user: User
}

export default function UsersItem({ user }: UsersItemProps) {
	return (
		<Card>
			<CardContent>
				<Grid container direction={"row"} spacing={6} alignItems="center">
					<Grid item md={4}>
						<Typography>
							{user.id} - <b>{user.name}</b>
							<br />
							{user.corporate}
						</Typography>
					</Grid>
					<Grid item md={4} style={{ textAlign: 'center' }}>
						<Typography>
							{user.email}
							<br/>
							Estudos Realizados: {user.studiesCount}
						</Typography>
					</Grid>
					<Grid item md={4} style={{ textAlign: 'right' }}>
						<Typography>
							{user?.phone}
							<br />
							{user?.cnpj}
						</Typography>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
}